import * as React from "react";

const BreadcrumbRightArrowSVG = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10">
        <path
            fillOpacity="0.541"
            d="M1.142 0 0 1.175 3.708 5 0 8.825 1.142 10 6 5z"
        ></path>
    </svg>
);

export default BreadcrumbRightArrowSVG;
